import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Paper,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

interface SearchFormProps {
  onSearch: (params: any) => void;
  sources: Array<{
    id: string;
    name: string;
    type: string;
  }>;
}

const HotelSearchForm: React.FC<SearchFormProps> = ({ onSearch, sources }) => {
  const [searchParams, setSearchParams] = useState({
    source: '',
    keywords: '',
    location: '',
    price: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({
      ...prev,
      [name as string]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchParams);
  };

  return (
    <Paper component="form" onSubmit={handleSubmit} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Search External Sources
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth>
            <InputLabel>Source</InputLabel>
            <Select
              name="source"
              value={searchParams.source}
              onChange={(e) => handleChange(e as any)}
              label="Source"
              required
            >
              {sources.map(source => (
                <MenuItem key={source.id} value={source.type}>
                  {source.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            name="keywords"
            label="Keywords"
            value={searchParams.keywords}
            onChange={handleChange}
            placeholder="e.g., luxury hotel, resort"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            name="location"
            label="Location"
            value={searchParams.location}
            onChange={handleChange}
            placeholder="e.g., Miami, FL"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            name="price"
            label="Price Range"
            value={searchParams.price}
            onChange={handleChange}
            placeholder="e.g., 1000000-5000000"
          />
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              size="large"
            >
              Search
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default HotelSearchForm;